export default __webpack_public_path__ + "static/media/sarisari-mobile.a0c24d35.jpg";